import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Link } from 'foundations-components/transitional/components/Link';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import withErrorBoundary from '../ErrorBoundary';
import { MC_0653_EMAIL_SENDS_COUNTER } from '../_core/common/constants/ErrorBoundaryNames';
import { USAGE_LIMIT_BANNER } from '../_core/common/constants/PurchaseMotionLocations';
import { track } from '../_core/common/eventTracking/tracker';
import { PRICING_PAGE_REDIRECT } from '../_core/purchaseMotions/PurchaseMotionTypes';
import { getUpgradeDataFromUpgradeConfig } from '../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIPurchaseMotionButton from '../button/UIPurchaseMotionButton';
import { getUpgradeDataTrackingProperties, updateViewedUpgradePointsCache } from '../ums/utils';
import { MC0653_EMAIL_SENDS_UPGRADE_CONFIG } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MC0653EmailSendsCounter = ({
  value,
  limit
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(MC0653_EMAIL_SENDS_UPGRADE_CONFIG);
  const sendsRemaining = Math.max(0, limit - value);
  const today = new Date();
  const firstDayOfNextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
  const limitInteractionTrackingData = {
    limit,
    value,
    displayThreshold: 0,
    hasReachedLimit: value >= limit
  };
  const trackViewedToolTip = event => {
    if (event && event.target && event.target.value === true) {
      updateViewedUpgradePointsCache(MC0653_EMAIL_SENDS_UPGRADE_CONFIG.upgradeKey, () => {
        track('interaction', Object.assign({
          action: 'viewed upgrade point'
        }, limitInteractionTrackingData, getUpgradeDataTrackingProperties(upgradeData)));
      });
    }
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "upgrades.mc0653.emailSendsCounter.sentThisMonth",
      options: {
        value,
        limit
      }
    }), /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      use: "longform",
      maxInlineSize: "500px",
      onOpenChange: trackViewedToolTip,
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.mc0653.emailSendsCounter.popover.header"
      }),
      title: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs(Text, {
          as: "small",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.mc0653.emailSendsCounter.popover.limitReset"
          }), "\xA0", /*#__PURE__*/_jsx(FormattedDateTime, {
            value: firstDayOfNextMonth,
            format: "short-date"
          }), "."]
        }), /*#__PURE__*/_jsx(View, {
          minInlineSize: "400px",
          marginBlockStart: "400",
          children: /*#__PURE__*/_jsx(Progress, {
            "aria-label": "Progress Bar",
            use: "warning",
            value: value / limit * 100,
            descriptiveLabel: /*#__PURE__*/_jsx(Text, {
              as: "small",
              typography: "heading-25",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "upgrades.mc0653.emailSendsCounter.popover.progressBar.sendsRemaining",
                options: {
                  sendsRemaining
                }
              })
            }),
            valueLabel: /*#__PURE__*/_jsx(Text, {
              as: "small",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "upgrades.mc0653.emailSendsCounter.popover.progressBar.emailsSent",
                options: {
                  value,
                  limit
                }
              })
            })
          })
        }), /*#__PURE__*/_jsx(Flex, {
          display: "inline-flex",
          children: /*#__PURE__*/_jsx(UIPurchaseMotionButton, {
            use: "link",
            block: false,
            upgradeData: upgradeData,
            level: 1,
            purchaseMotions: [PRICING_PAGE_REDIRECT],
            goToUpgradePage: true,
            location: USAGE_LIMIT_BANNER,
            usageLimitBannerData: {
              limit,
              value,
              displayThreshold: 0,
              hasReachedLimit: value >= limit
            },
            children: /*#__PURE__*/_jsx(Text, {
              typography: "body-100",
              children: /*#__PURE__*/_jsx(Link, {
                external: true,
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "upgrades.upgradeButton.mc0653Cta"
                })
              })
            })
          })
        })]
      }),
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        children: /*#__PURE__*/_jsx(IconHolder, {
          icon: InfoIcon,
          color: "icon-core-subtle",
          size: "300",
          paddingInlineStart: "50",
          paddingBlock: "0"
        })
      })
    })]
  });
};
export default withErrorBoundary(MC0653EmailSendsCounter, {
  boundaryName: MC_0653_EMAIL_SENDS_COUNTER
});